import Vue from "vue";

export default {
  handleSizeChangeJobPosting({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getAllJobPostings");
  },
  handleCurrentChangeJobPosting({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAllJobPostings");
  },
  // Create a new job posting
  createJobPosting({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/recruitment/job-postings`, params)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
          commit("tableLoading", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoading", false);
        });
    });
  },

  // Update an existing job posting by ID
  updateJobPosting(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/recruitment/job-postings/${payload.id}`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get a job posting by ID
  getJobPostingById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/recruitment/job-postings/${id}`)
        .then(response => {
          commit("setSelectedRow", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get all job postings
  getAllJobPostings({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      const params = {
        page: state.currentPage,
        per_page: state.perPage,
        ...(payload && payload),
      };
      Vue.$http
        .get("/hrm/recruitment/job-postings", { params })
        .then(response => {
          commit("jobPostings", response.data.results);
          commit("paginationTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  // Archive a job posting by ID
  archiveJobPosting(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/recruitment/job-postings/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getArchivedJobPostings({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      const params = {
        page: state.currentPage,
        per_page: state.perPage,
        ...(payload && payload),
      };
      Vue.$http
        .get("/hrm/recruitment/job-postings/archives", { params })
        .then(response => {
          commit("archivedJobPostings", response.data.results);
          commit("paginationTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  restoreArchivedJobPostings(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/recruitment/job-postings/restore`, { ids: payload.ids })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deleteArchivedJobPostings(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/recruitment/job-postings/archives`, {
          data: { ids: payload.ids },
        })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Publish a job posting by ID
  publishJobPosting(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/recruitment/job-postings/publish/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Publish a job posting by ID
  unPublishJobPosting(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/recruitment/job-postings/unpublish/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Create a new job board
  createJobBoard({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/recruitment/job-boards`, params)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
          commit("tableLoading", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoading", false);
        });
    });
  },

  // Update an existing job board by ID
  updateJobBoard(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/recruitment/job-boards/${payload.id}`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get a job board by ID
  getJobBoardById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/recruitment/job-boards/${id}`)
        .then(response => {
          commit("setSelectedRow", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  handleSizeChangeJobBoards({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getAllJobBoards");
  },
  handleCurrentChangeJobBoards({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAllJobBoards");
  },

  // Get all job boards
  getAllJobBoards({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      const params = {
        page: state.currentPage,
        per_page: state.perPage,
        ...(payload && payload),
      };
      Vue.$http
        .get("/hrm/recruitment/job-boards", { params })
        .then(response => {
          commit("jobBoards", response.data.results);
          commit("paginationTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  // Delete a job board by ID
  deleteJobBoard(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/recruitment/job-boards/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
